
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restorePassword",
      function () {
        return require("private-next-pages/restorePassword/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restorePassword"])
      });
    }
  